import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SettingsService, AuthService } from '../service';
import { Sale } from './sale.interface';
import { Search } from '../shared/interfaces/search.interface';


@Injectable()
export class DashboardService {
    constructor(
        private http: HttpClient,
        private settings: SettingsService,
        private authService: AuthService
    ) { }

    public getSales(search: Search): Observable<Sale[]> {
        const headers = new HttpHeaders({
            'LoginRole': `${this.authService.getUserLoginRole()}`,
            'Authorization': `${this.authService.getUserToken()}`
        });

        return this.http.post<Sale[]>(`${this.settings.serverMain}Payment/GetIncomings`, search, { headers: headers });
    }
}
